module.exports = __webpack_public_path__ + "img/bus_title_img_3.4b5612f5.svg";